module.exports = {
  BulletsData: () => {
    return {

      "mg_zs_hybrid_2025" : {
        "external" :
          [
            {
              "id" : "nueva_santa_fe-lateral",
              "title": "",
              "text": "Más largo. Más alto. Más imponente que nunca. Con un nuevo diseño, el Nuevo Santa Fe se destaca por contar con un exterior elegante y robusto desde todos sus ángulos. Su altitud y tamaño aportan un toque único a una carrocería modelada con audacia y perfección.",
              "image": require('../assets/bullets/nueva_santa_fe/01.webp'),
              "active": true,
              "position": {
                x: 1.1,
                y: 1.0,
                z: -0.4
              },
              "camera": {
                pitch: -21,
                yaw: 98.45,
                distance: 5,
              }
            },
            {
              "id" : "nueva_santa_fe-luces",
              "title": "",
              "text": 'Luces traseras LED también con diseño característico en forma de "H"',
              "image": "",
              "active": true,
              "position": {
                x: 0.0,
                y: 0.9,
                z: -2.55
              },
              "camera": {
                pitch: -10.0,
                yaw: 179.0,
                distance: 4.2,
              }
            },
          ],
        "internal" : 
          [],
      },
      
    }
  }
}